import store from '../../store';
import * as Actions from '../../store/actions';

class alertMessage {

    showSuccessMessage = message => {
        store.dispatch(Actions.showMessage({
            message,//text or html
            autoHideDuration: 5000,//ms
            anchorOrigin: {
                vertical  : 'top',//top bottom
                horizontal: 'right'//left center right
            },
            variant: 'success'
        }));
    }
    
    showErrorMessage = message => {
        console.log("message show",message);
        store.dispatch(Actions.showMessage({
            message,//text or html
            autoHideDuration: 5000,//ms
            anchorOrigin: {
                vertical  : 'top',//top bottom
                horizontal: 'right'//left center right
            },
            variant: 'error'
        }));
    } 
}

const instance = new alertMessage();

export default instance;